export default {
    graphqlServer: 'graphql.appotime.com',
    stripe: {
        public:
            'pk_live_51OHmqTClrAD23848FXNlmQwPrftzypXbSxfDyENxONbLpgkchUqIL9FKl7eRClpKWBlZkqjjS0w5nbbrcV128Shb00kJzfh9AU',
    },
};
